import React, {useState, useEffect} from 'react'
import { Select, Input, DatePicker} from 'antd'
import moment from 'moment'
import { getListShippingCarrierApp } from '../../../../services/api/apiFFM'

function CombineShipFilter(props) {
    const { RangePicker } = DatePicker
    const { Option } = Select
    const {
        status, lineShip,
        loading, batch,
        handleChangeStatus,
        handleChangeBatch, searchValue,
        handleChangeCreated,
        createdStart,createdEnd,
        itemType, handleChangeItemType,
        handleSearchBatch, handleChangeLineShip,
        onChangePackingCreated, packingEnd, packingStart
    } = props
    const dateFormat= "YYYY-MM-DD"
    const datePackingFormat= "YYYY-MM-DD HH:mm"
    const dateFilterValue= createdStart && createdEnd ? [moment(createdStart, dateFormat), moment(createdEnd, dateFormat)] : []
    const datePackingFilterValue= packingStart && packingEnd ? [moment(packingStart, datePackingFormat), moment(packingEnd, datePackingFormat)] : []

    const [listShippingCarrier, setListShippingCarrier] = useState([])
    const [allShippingCarrier, setAllShippingCarrier] = useState([])

    const fetchFiltersShippingCarrier = async(payload) => {
        try {
            const newPayload = {
                ...payload,
                limit: 10000,
                page: 1,
            }

            const res = await getListShippingCarrierApp(newPayload)
            const {data, success, message} = {...res}
            if (!success) {
                throw new Error(message)
            }
            const shippingCarriers = !!data.shippingCarriers && data.shippingCarriers.length > 0 ? data.shippingCarriers.sort((a, b) => {
                const nameA = a.name.toUpperCase()
                const nameB = b.name.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0
            }) : []
            setListShippingCarrier(shippingCarriers.filter(i => !!i.is_active) || [])
            setAllShippingCarrier(shippingCarriers || [])
            
        } catch (error) {
            alert(error.message)
        }
    } 

    useEffect(()=>{
        fetchFiltersShippingCarrier()
    },[])

    const shippingCarrierOptions = !!listShippingCarrier && listShippingCarrier.length > 0 ? listShippingCarrier.map(i=> ({
        value: i.slug,
        name: i.name,
        is_active: i.is_active,
    })) : []

    return (
        <div className='BatchShipFilter TableFilter d-xl-flex justify-content-between align-items-end'>
            <div className="Filter">
                <div className="d-flex flex-wrap justify-content-start">
                    <div className="FilterWrapper FilterOptions mr-2 mb-3">
                        <div className="CustomSelect d-flex align-items-stretch justify-content-end">
                            <Select
                                style={{ width: "400px" }}
                                mode='tags'
                                placeholder='Search: ID đơn gộp ship, mã đơn'
                                onChange={handleChangeBatch}
                                allowClear
                                disabled={loading}
                                open={false}
                                searchValue={searchValue || ''}
                                onSearch={handleSearchBatch}
                                value={batch.length? batch : []}
                            />
                        </div>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "200px" }}
                            placeholder="-- Type --"
                            allowClear
                            value={itemType || []}
                            onChange={handleChangeItemType}
                            disabled={loading}
                        >
                            <Option value='normal'>Thường</Option>
                            <Option value='fast'>Nhanh</Option>
                        </Select>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "200px" }}
                            placeholder="-- Order status --"
                            allowClear
                            value={status || []}
                            onChange={handleChangeStatus}
                            disabled={loading}
                        >
                            <Option value='in_production'>In production</Option>
                            <Option value='confirmed'>Confirmed</Option>
                            <Option value='completed'>Completed</Option>
                            <Option value='cancelled'>Cancelled</Option>
                            <Option value='shipped'>Shipped</Option>
                        </Select>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <Select
                            style={{ minWidth: "200px" }}
                            placeholder="-- Line ship --"
                            value={lineShip || []}
                            onChange={handleChangeLineShip}
                            allowClear
                            disabled={loading}
                            showSearch
                            onSearch={(value) => {
                                if (value) {
                                    const newList = allShippingCarrier.filter(i => !!i.name.toLowerCase().includes(value.toLowerCase()))
                                    setListShippingCarrier(newList)
                                } else { setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active)) }
                            }}
                            onBlur={() => setListShippingCarrier(allShippingCarrier.filter(i => !!i.is_active))}
                            filterOption={(input, option) => {
                                return option.children.toLowerCase().includes(input.toLowerCase())
                            }}
                        >
                            {!!shippingCarrierOptions.length && shippingCarrierOptions.map((i, index) => (
                                <Option value={i.value} key={index} style={!i.is_active ? {} : { color: '#333' }}>{i.name}</Option>
                            ))}
                            <Option value={'other'} key={'other'}>Other</Option>
                        </Select>
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <RangePicker
                            id='createdAt'
                            placeholder={['Created start', 'Created end']}
                            ranges={{
                                'Today': [moment().startOf('day'), moment().endOf('day')],
                                'Last 7 Days': [moment().subtract(6, 'day').startOf('day'), moment().endOf('day')],
                                'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
                            }}
                            format={dateFormat}
                            onChange={handleChangeCreated}
                            popupStyle={{ maxWidth: '600px' }}
                            disabled={loading}
                            value={dateFilterValue}
                        />
                    </div>

                    <div className='CustomSelect FilterOptions mr-2 mb-3'>
                        <RangePicker
                            id='packingAt'
                            placeholder={['Packing start', 'Packing end']}
                            ranges={{
                                'Today': [moment().startOf('day'), moment().endOf('day')],
                                'Last 7 Days': [moment().subtract(6, 'day').startOf('day'), moment().endOf('day')],
                                'This Month': [moment().startOf('month').startOf('day'), moment().endOf('month').endOf('day')],
                            }}
                            format={datePackingFormat}
                            onChange={onChangePackingCreated}
                            popupStyle={{ maxWidth: '600px' }}
                            disabled={loading}
                            value={datePackingFilterValue}
                            showTime={{ format: 'HH:mm' }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CombineShipFilter